import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';

const client = generateClient();

export const recommendMealsOperation = async (
  mealTypes,
  numDays,
  existingDays,
  startDayIndex,
  constraints,
  personalisationData,
  alternativeMealParentIDs,
  calorieSplits,
  servings,
  personalisedMealScaling,
  sources,
  targetCaloriesPerDay,
  locales,
) => {
  const menuRecommendationRequest = {
    mealTypes,
    numDays,
    existingDays,
    constraints,
    personalisationData,
    startDayIndex,
    alternativeMealParentIDs,
    calorieSplits,
    servings,
    personalisedMealScaling,
    sources,
    targetCaloriesPerDay,
    locales,
  };
  const recommendMealsResponse = await client.graphql({
    query: mutations.recommendMeals,
    variables: { menuRecommendationRequest },
  });
  console.log({ recommendMealsResponse });
  return recommendMealsResponse.data.recommendMeals;
};
